<template>
  <div class="cs-container">
    <input
      ref="inputFileData"
      type="file"
      multiple
      charset="utf-8"
      accept=".stp, .step, .stl"
      v-show="false"
      @change="changeInputFile"
    />
    <div class="flex items-end px-2 mb-3">
      <h1 class="text-5xl font-bold md:text-4xl">견적서</h1>
    </div>
    <div class="w-full h-full md:flex">
      <div class="w-full">
        <div class="flex justify-end items-center mb-2 w-full">
          <button
            class="flex items-center px-3 py-2 text-center cs-btn cs-btn-default"
            @click="onGoAR"
          >
            <img src="../assets/images/3d.png" class="m-auto mr-1 w-5" />
            <span class="block mt-1 text-xs font-medium">AR Viewer</span>
          </button>
          <div class="w-[5px]"></div>
          <button
            class="flex items-center px-3 py-2 text-center cs-btn cs-btn-default"
            @click="onGoPacking"
          >
            <img src="../assets/images/delivery-box.png" class="m-auto mr-1 w-5" />
            <span class="block mt-1 text-xs font-medium">3D Packing</span>
          </button>
        </div>

        <client-model v-for="model in models" :key="model.id" :model="model"></client-model>
        <div
          ref="dragDropContainer"
          class="relative py-10 w-full text-center bg-white rounded-md border border-b-2 border-line upload-area"
          v-cloak
          @dragenter.prevent="onDragEnter"
          @dragend.prevent="onDragEnd"
        >
          <div class="">
            <button
              class="m-auto w-80 cs-btn cs-pd-btn-sm"
              :class="isEstimateSubmit ? 'cs-btn-second' : 'cs-btn-disabled'"
              :disabled="!isEstimateSubmit"
              @click="inputFileFocus"
            >
              <div class="flex justify-center items-center text-xl font-bold">
                <i class="text-xl fi fi-rr-cloud-upload-alt"></i>
                <span class="ml-1">STL, STP, STEP 파일 업로드</span>
              </div>
            </button>
            <div class="m-auto mt-2 w-80 cs-caption">
              <i class="mr-1 fi fi-br-exclamation"></i>
              <div class="text-left">
                <p style="line-height: 1.3">
                  최대 10개 모델 업로드 가능합니다.<br /><span class="hidden md:inline"
                    >해당 영역에 드래그&드롭으로 업로드 가능합니다.</span
                  >
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="flex justify-center mt-6">
            <div class="flex items-center">
              <span class="mr-3 text-default">단위선택</span>
              <div class="flex">
                <button class="px-4 py-2 rounded-l-full border-t border-b border-l border-input" :class="['mm' === unit ? 'bg-white' : 'unit-unactive']" @click="onUnit('mm')">
                  <span class="" :class="['mm' === unit ? 'font-semibold' : 'text-placeholder']">mm</span>
                </button>
                <span class="border-l border-input"></span>
                <button class="px-4 py-2 rounded-r-full border-t border-r border-b border-input" :class="['inch' === unit ? 'bg-white' : 'unit-unactive']" @click="onUnit('inch')">
                  <span class="" :class="['inch' === unit ? 'font-semibold' : 'text-placeholder']">inch</span>
                </button>
              </div>
            </div>
          </div> -->
          <div class="px-5 mt-6 md:mt-8">
            <p class="leading-4 text-placeholder" style="font-size: 0.95rem">
              업로드하신 파일은 암호화되어 보관됩니다. 업로드하시면
              <button class="font-semibold cursor-pointer text-second" @click="onTerm">
                이용 약관</button
              >에 동의하신 것으로 간주합니다.
            </p>
          </div>

          <div
            v-if="isDraging"
            class="drop-area"
            ref="dropContent"
            id="dropContent"
            v-cloak
            @drop.prevent="onDrop"
            @dragenter.prevent
            @dragover.prevent
            @dragleave.stop="onDragLeave"
          >
            <div class="drop-area-inner" :class="{active: isDraging}">
              <i
                class="text-4xl text-white fi fi-sr-cloud-upload-alt drop-area-icon md:text-7xl"
              ></i>
              <div class="text-white drop-area-desc">
                <p class="font-semibold md:text-lg">파일을 업로드하려면 여기에 드롭하세요.</p>
              </div>
            </div>
          </div>

          <div
            v-if="AnalysisStatus.Fail === isEnabled"
            class="justify-center items-center w-full h-full rounded-md"
          >
            <div class="text-center bounding-loader-fail-text bg-black-500">
              <p class="text-white md:text-xl">
                시스템 설정이 필요합니다, 관리자에게 문의해주세요.
              </p>
            </div>
          </div>
          <div
            v-else-if="AnalysisStatus.Pass !== isEnabled"
            class="justify-center items-center rounded-md bounding-loader"
          >
            <div class="loader-boxs">
              <div class="scene">
                <div class="plane">
                  <div class="cube cube--0">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--0"></div>
                  <div class="cube cube--1">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--1"></div>
                  <div class="cube cube--2">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--2"></div>
                  <div class="cube cube--3">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--3"></div>
                  <div class="cube cube--4">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--4"></div>
                  <div class="cube cube--5">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--5"></div>
                  <div class="cube cube--6">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--6"></div>
                  <div class="cube cube--7">
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                    <div class="cube__side"></div>
                  </div>
                  <div class="shadow shadow--7"></div>
                </div>
              </div>
            </div>
            <div class="text-center bounding-loader-text">
              <p v-if="AnalysisStatus.Processing === isEnabled" class="md:text-xl">
                초기화 중 입니다, 잠시만 기다려주세요.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 md:w-10 md:mt-0 md:px-2" style="min-width: 330px">
        <div
          class="overflow-hidden rounded-md border border-b-2 estimate-content border-line md:sticky"
        >
          <div class="flex relative justify-center items-center py-3 bg-black">
            <img class="sub-logo" src="../assets/images/logo.png" />
          </div>
          <div class="px-7 py-4 text-sm leading-5 text-center bg-deepgray text-gray">
            <p>3D모델을 자동으로 분석하여 프린팅시</p>
            <p>위험요소 및 견적을 자동으로 분석합니다.</p>
          </div>
          <div class="flex justify-between px-7 bg-white border-b border-line">
            <div class="flex justify-between py-5 w-full font-normal">
              <p class="text-placeholder">총 모델</p>
              <p class="text-right">{{ models.length }} 개</p>
            </div>
            <div class="mr-5 ml-5 border-l border-line"></div>
            <div class="flex justify-between py-5 w-full font-normal">
              <p class="text-placeholder">총 수량</p>
              <p class="text-right">{{ totalModelQuantiy }} 개</p>
            </div>
          </div>
          <div class="px-7 py-6 bg-white border-b border-line">
            <div class="flex justify-between font-normal">
              <p class="text-placeholder">출력 비용</p>
              <p class="text-right">
                {{ numberToComma(estimate.buildCost ? estimate.buildCost : 0) }} 원
              </p>
            </div>
            <div class="flex justify-between mt-6 font-normal">
              <p class="text-placeholder">배송 비용</p>
              <p class="text-right">{{ shippingCost }} 원</p>
            </div>
            <div class="flex justify-between mt-6 font-normal">
              <p class="text-placeholder">동시제작 할인비용</p>
              <p
                class="text-lg font-semibold text-right"
                :class="0 > estimate.discountCost * -1 ? 'text-danger' : ''"
              >
                {{ discountCost }} 원
              </p>
            </div>
          </div>
          <div class="px-7 py-4 bg-white">
            <!-- <div class="flex justify-between font-normal">
              <p class="text-placeholder">부가세 V.A.T (예상)</p>
              <p class="text-right">{{ numberToComma(estimate.modelCost ? Math.floor((estimate.modelCost + estimate.shippingCost) * 0.1) : 0) }}원</p>
            </div> -->
            <div class="mt-3 font-normal md:mt-3 md:flex md:justify-between">
              <p class="mt-1 font-semibold">총 비용 (예상)</p>
              <p class="mt-2 text-4xl font-bold text-right text-second md:mt-0">
                {{ totalCost }}원
              </p>
            </div>
          </div>
          <div class="px-7 pt-5 pb-5 bg-white">
            <button
              class="w-full cs-btn cs-pd-btn"
              :class="models.length && isEstimateSubmit ? 'cs-btn-base' : 'cs-btn-disabled'"
              :disabled="!isEstimateSubmit"
              @click="onSubmit"
            >
              <span class="text-xl font-bold">견적 문의하기</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="p-4 w-full text-xs leading-4 text-center bg-black text-lightgray md:text-sm"
      style="position: fixed; left: 0px; bottom: 0px"
    >
      본 시스템에 대한 권리는 (주)하이쓰리디에게 있으며 무단 복제, 링크 연동, AI 훈련에 사용시 법적
      조치 될 수 있습니다.
    </div>

    <modal-analysis v-if="isVisibleViewer" :model="currentModel"></modal-analysis>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sub-logo {
  height: 30px;
}

.upload-area {
  transition: 0.2s all;

  &:hover {
    border: 1px solid #c5e1ff;
    background-color: #f7fbff;
  }
}

.unit-unactive {
  background-color: rgb(243 244 246);
}

.estimate-content {
  top: 1rem;
}
</style>

<script setup>
/******************************************
 * 하이쓰리디 - 클라이언트 견적서 화면
 ******************************************/
import {ref, computed, onMounted, watch} from "vue";
import {storeToRefs} from "pinia";
import ClientModel from "./client-model.vue";

import {OptionsStore} from "../store/options-store";
import {EstimateStore} from "../store/estimate-store";
import {ModelStore} from "../store/model-store";
import {CommonStore} from "../store/common-store";

import {changeInputFile, preProcessingFileUpload} from "../js/upload";
import {AnalysisStatus, Modals} from "../js/types";
import {numberToComma} from "../js/utils";

import ModalAnalysis from "./modals/modal-analysis.vue";
import ModalClientSubmit from "./modals/modal-client-submit.vue";

import {socketJoin} from "../js/socket";
import {toast} from "vue3-toastify";

const commonStore = CommonStore();
const {modalResult} = storeToRefs(commonStore);
const optionsStore = OptionsStore();
const {isEnabled} = storeToRefs(optionsStore);
const estimateStore = EstimateStore();
const {estimate, isEstimateSubmit} = storeToRefs(estimateStore);
const {models, currentModel, totalQua} = storeToRefs(ModelStore());
const inputFileData = ref();

const isDraging = ref(false);
const isVisibleViewer = ref(false);

const shippingCost = computed(() => {
  return numberToComma(models.value.length ? estimate.value.shippingCost : 0);
});
const discountCost = computed(() => {
  return numberToComma(models.value.length ? estimate.value.discountCost * -1 : 0);
});
const totalCost = computed(() => {
  const vat = 0;
  return models.value.length ? numberToComma(estimate.value.totalCost + vat) : 0;
});
const totalModelQuantiy = computed(() => {
  return totalQua;
});

watch(currentModel, (newV) => {
  if (newV.id) {
    isVisibleViewer.value = true;
  } else {
    isVisibleViewer.value = false;
  }
});
watch(modalResult, (newV) => {
  switch (newV.modalName) {
    case Modals.SubmiEstimate:
      window.location.href = process.env.VUE_APP_BASE_WEB_URL;
      break;
  }
});

onMounted(() => {
  if (estimate.value.id) {
    return;
  }
  estimateStore.createEstimate();
  optionsStore.reqGetOptions();

  socketJoin();
});

/************************************************************
 * Event
 ***********************************************************/
const inputFileFocus = () => {
  if (inputFileData.value) {
    inputFileData.value.click();
  }
};

const onTerm = () => {
  CommonStore().showTermModal();
};

/************************************************************
 * Drag
 ***********************************************************/
const onDrop = (e) => {
  isDraging.value = false;

  e.preventDefault();

  if (e.dataTransfer) {
    let droppedFiles = e.dataTransfer.files;
    if (!droppedFiles) return;
    if (!isEstimateSubmit.value) return;

    preProcessingFileUpload(droppedFiles);
  }
};

const onDragEnter = () => {
  isDraging.value = true;
};

const onDragLeave = () => {
  isDraging.value = false;
};

const onDragEnd = () => {
  isDraging.value = false;
};

/************************************************************
 * Submit
 ***********************************************************/
const onSubmit = () => {
  CommonStore().showModal(ModalClientSubmit, null);
};
const onGoAR = () => {
  const arUrl = process.env.VUE_APP_API_SERVER_URL + "/ar";
  window.open(arUrl, "_blank");
};
const onGoPacking = () => {
  if (estimate.value && estimate.value.id) {
    if (models.value.length) {
      window.open(`/packing-viewer?estimateId=${estimate.value.id}`, "_blank");
    } else {
      toast.warning("파일을 업로드 해주세요.", {position: toast.POSITION.TOP_CENTER});
    }
  }
};
</script>
